import React, { useEffect, useState } from "react";
import { Card, Row, Col, Statistic, Spin, Alert } from "antd";
import { sync_status } from "./../../api/admin.apis"; // adjust path

const SyncStatus = () => {
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSyncStatus();
  }, []);

  const fetchSyncStatus = async () => {
    try {
      setLoading(true);
      const res = await sync_status();
      setSummary(res.data.data.summary);
    } catch (err) {
      setError("Failed to load sync status");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Spin size="large" />;
  }

  if (error) {
    return <Alert type="error" message={error} />;
  }

  if (!summary) return null;

  return (
    <Card title="GA4 Sync Status">
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8}>
          <Statistic title="Total Connections" value={summary.total_connections} />
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Statistic title="Healthy" value={summary.healthy} valueStyle={{ color: "#3f8600" }} />
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Statistic title="Issues" value={summary.issues} valueStyle={{ color: "#cf1322" }} />
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Statistic title="Expired" value={summary.expired} />
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Statistic title="Error" value={summary.error} />
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Statistic title="Disabled" value={summary.disabled} />
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Statistic title="Inactive" value={summary.inactive} />
        </Col>
      </Row>
    </Card>
  );
};

export default SyncStatus;
